{
  "hasActionAnnouncement": "row has action",
  "hasLinkAnnouncement": "row has link: {link}"
}
